// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2ZX9M","content":"GlobalSearch_content__3TYui"};